module.exports = __webpack_public_path__ + "fonts/montserrat-v14-cyrillic-ext_cyrillic_latin_latin-ext-600.woff2";